import { createSlice } from "@reduxjs/toolkit";
import { fetchKbArticles, searchKbArticles } from "../Action/KbAction";

const kbSlice = createSlice({
  name: "kb",
  initialState: {
    articles: [],
    totalItems: 0,
    searchResults: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearSearchResults: (state) => {
      state.searchResults = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKbArticles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchKbArticles.fulfilled, (state, action) => {
        state.loading = false;
        state.articles = action.payload.data;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchKbArticles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(searchKbArticles.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchKbArticles.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload;
      })
      .addCase(searchKbArticles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSearchResults } = kbSlice.actions;
export default kbSlice.reducer;
